import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 20px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
				
              <div className="col-md-7">
					
					<div className="pq-section pq-style-1 text-center">
					  <h2 className="pq-section-title">Frequently Asked Questions (FAQ’s)</h2>
					</div>
					
					<div className="col-xl-12 mt-xl-0 ps-xl-3">
					  <div className="pq-accordion-block mt-4">
						{[ 
						  { question: "What services are included in advanced audiology care?", answer: "Advanced audiology includes hearing tests, diagnostic evaluations, tinnitus assessment, balance testing, hearing aid trials, cochlear implant evaluation, and rehabilitation. These services help identify hearing problems early and provide the right treatment or assistive solutions for long-term hearing health." },
						  { question: "When should I get my hearing tested?", answer: "You should get your hearing tested if you experience difficulty hearing conversations, ringing in the ears, ear fullness, frequent asking for repetitions, dizziness, or sudden hearing changes. Adults above 40 should have routine hearing checks even without symptoms, as hearing loss can progress silently." },
						  { question: "Are hearing aids effective for all types of hearing loss?", answer: "Hearing aids are highly effective for most mild to severe sensorineural hearing losses. After a detailed audiological evaluation, the specialist recommends the right device based on your hearing pattern, lifestyle, and communication needs. Some conditions may require surgery or cochlear implants instead of hearing aids." },
						  {question: "What is the difference between a hearing test and an audiology evaluation?", answer: "A basic hearing test measures how well you hear different sounds, while a full audiology evaluation includes speech tests, tympanometry, OAE, BERA, tinnitus assessment, and middle-ear analysis. It provides a complete picture of your ear and hearing function to guide accurate treatment."},
						  {question: "How do I know if I need hearing aids or medical treatment?", answer: "After examining your ears and reviewing your audiology report, the ENT specialist determines whether you need medication, surgery, hearing aids, or rehabilitation. Conditions like earwax, infections, perforations, or fluid buildup may need medical treatment, while permanent hearing loss usually requires hearing devices."}
						].map((item, index) => (
						  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
							<div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
							  <h4 className="ad-title-text">
								{item.question}
								<i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
							  </h4>
							</div>
							<div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
							  <p className="pq-detail-text">{item.answer}</p>
							</div>
						  </div>
						))}
					  </div>
					</div>
				</div>
				<div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                      <iframe width="100%" height="300px" src="https://www.youtube.com/embed/eE49T3B_4kM" title="Tonsillectomy" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></iframe>
                       <div class="p-3"><h5 class="text-success mb-0">What is Tympanometry?|टिम्पेनोमेट्री क्या है| By Dr. Major Rajesh Bhardwaj</h5></div>
				  </div>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
}
